import { UserState } from '../../userSlice';

/**
 * Доступ к приложению только при явном is_active === true.
 * Иначе (false, undefined) — экран «аккаунт на проверке», для любой организации.
 */
export const isUserAccountActive = (user: UserState | null | undefined): boolean => {
  return user != null && user.is_active === true;
};

/**
 * Проверяет, имеет ли пользователь доступ к разделу протоколов
 * Доступ есть только у пользователей организации "Public"
 */
export const hasProtocolsAccess = (user: UserState | null): boolean => {
  if (!user) return false;
  return user.organization === 'Public';
};

/**
 * Проверяет, может ли пользователь создавать протоколы
 */
export const canCreateProtocols = (user: UserState | null): boolean => {
  return hasProtocolsAccess(user);
};

/**
 * Проверяет, может ли пользователь просматривать протоколы
 */
export const canViewProtocols = (user: UserState | null): boolean => {
  return hasProtocolsAccess(user);
};

/**
 * Проверяет, имеет ли пользователь доступ к Copilot
 * Доступ есть только у пользователей организаций "BudZdorov", "LazyDoc" и "Апрель"
 */
export const hasCopilotAccess = (user: UserState | null): boolean => {
  if (!user) return false;
  return user.organization === 'BudZdorov' || user.organization === 'LazyDoc' || user.organization === 'Апрель';
};
